import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

import { useGetSearchPartList } from "../../hooks";

import { HubHookFormSearchField } from "../HubHookFormSearchField";

export const HubHookFormPartSelectV2 = ({
  label = "Search for Part",
  placeholder = "Search for Part...",
  name = "partId",
  onChange = () => {},
  defaultValue,
  disabled,
  ...rest
}) => {
  const [value, setValue] = useState();
  const { getValues } = useFormContext();
  const defaultPartId = defaultValue || getValues(name);

  const { data } = useGetSearchPartList(value, defaultPartId);

  return (
    <HubHookFormSearchField
      name={name}
      label={label}
      placeholder={placeholder}
      defaultValue={defaultPartId}
      options={data || []}
      value={value}
      setValue={setValue}
      onChange={onChange}
      sx={{ ".HubSearch-Results": { marginTop: "30px" } }}
      debounceTime={1000}
      {...rest}
    />
  );
};

export default HubHookFormPartSelectV2;
